import http from "./httpService";
import config from "../config.json";
import auth from "./authService";

function categoryStoreUrl(id) {
  if (id) return `/v1/categories/${id}`;
  else return `/v1/categories`;
}

export function getCategories() {
  return http.get(categoryStoreUrl());
}

export function getDropDownCategories() {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/dropdown-categories`
  );
}

export function deleteCategory(categoryId) {
  return http.delete(categoryStoreUrl(categoryId));
}

export function saveCateogry(category) {
  return http.post(categoryStoreUrl(), category);
}

export function updateCategory(category) {
  return http.put(categoryStoreUrl(category.id), category);
}

export function updateCategoryStatus(category) {
  return http.get(`/v1/categories/${category.id}/status`);
}

export function getCategory(category) {
  return http.get(categoryStoreUrl(category));
}
